/**
 * stateTransformations
 * @params state Obj.
 * @params load Bool
 * @returns state Obj.
 * @Notes: stateTransformations is an attempt to
 * isolate actions that need to be taken to the state object
 * before it is saved, or when it is loaded. Because saveState
 * is call more often than loadState, most actions should only be
 * done on load.
 */
function stateTransformations(initialState, load = false) {
  const state = { ...initialState };
  if (load) {
    // Because rmi is no saved, and auth not set till later, must reset this
    if (state.session) state.session.rmiAuthSet = false;
  }

  // remove the rmi from the saved state, this prevents privacy leaks
  delete state.rmi;

  // remove the router information, because we don't want that to bleed into the next session
  delete state.router;

  return state;
}

export const clearLocalStorage = () => {
  localStorage.clear();
};

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('auth');
    if (!serializedState) {
      return undefined;
    }
    return stateTransformations(JSON.parse(serializedState), true);
  } catch (error) {
    return undefined;
  }
};

export const saveState = (state) => {
  localStorage.setItem('auth', JSON.stringify(stateTransformations(state)));
};
